import BookOrderMain from "@/pages/comp/book_order/main";
import BookOrderUseListPage from "@/pages/comp/book_order/book_order_use/list";
import TextBookListPage from "@/pages/comp/book_order/textbook/list";
import BookOrderListPage from "@/pages/comp/book_order/shop/order/book_list";
import TextBookStuUseListPage from "@/pages/comp/book_order/comp_textbook/stu_use_list";
import CompBookOrderListPage from "@/pages/comp/book_order/shop/order/comp_book_list";
import CompTextBookListViewPage from "@/pages/comp/book_order/comp_textbook/textbook_list_view";

const routerArr:object[] = [
  {
    path: "/comp/book_order/main",
    element: <BookOrderMain></BookOrderMain>,
  },
  {
    path: "/comp/book_order/book_order_use/list",
    element: <BookOrderUseListPage></BookOrderUseListPage>,
  },
  {
    path: "/comp/book_order/shop/order/comp_book_list",
    element: <CompBookOrderListPage></CompBookOrderListPage>,
  },
  {
    path: "/comp/book_order/textbook/list",
    element: <TextBookListPage></TextBookListPage>,
  },
  {
    path: "/comp/book_order/shop/order/book_list",
    element: <BookOrderListPage></BookOrderListPage>,
  },
  {
    path: "/comp/book_order/comp_textbook/stu_use_list",
    element: <TextBookStuUseListPage></TextBookStuUseListPage>,
  },
  {
    path: "/comp/book_order/comp_textbook/textbook_list_view",
    element: <CompTextBookListViewPage></CompTextBookListViewPage>,
  },
];

export default routerArr;